/* tslint:disable */
/* eslint-disable */
/**
 * chinaone-java
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface NormalOrderCheckInfoOrderCheckGoodsVo
 */
export interface NormalOrderCheckInfoOrderCheckGoodsVo {
    /**
     * 商品ID
     * @type {number}
     * @memberof NormalOrderCheckInfoOrderCheckGoodsVo
     */
    goodsId?: number;
    /**
     * 商品检查单ID
     * @type {number}
     * @memberof NormalOrderCheckInfoOrderCheckGoodsVo
     */
    checkOrderId?: number;
    /**
     * 商品编码
     * @type {string}
     * @memberof NormalOrderCheckInfoOrderCheckGoodsVo
     */
    goodsCode?: string;
    /**
     * 商品SKU ID
     * @type {number}
     * @memberof NormalOrderCheckInfoOrderCheckGoodsVo
     */
    skuId?: number;
    /**
     * 商品SKU编码
     * @type {string}
     * @memberof NormalOrderCheckInfoOrderCheckGoodsVo
     */
    skuCode?: string;
    /**
     * 商品图片URL
     * @type {string}
     * @memberof NormalOrderCheckInfoOrderCheckGoodsVo
     */
    goodsImgUrl?: string;
    /**
     * 商品名称
     * @type {string}
     * @memberof NormalOrderCheckInfoOrderCheckGoodsVo
     */
    goodsName?: string;
    /**
     * 商品颜色
     * @type {string}
     * @memberof NormalOrderCheckInfoOrderCheckGoodsVo
     */
    goodsColor?: string;
    /**
     * 商品尺寸
     * @type {string}
     * @memberof NormalOrderCheckInfoOrderCheckGoodsVo
     */
    goodsSize?: string;
    /**
     * 商品量
     * @type {number}
     * @memberof NormalOrderCheckInfoOrderCheckGoodsVo
     */
    goodsQuantity?: number;
    /**
     * 快递单号
     * @type {string}
     * @memberof NormalOrderCheckInfoOrderCheckGoodsVo
     */
    trackingNumber?: string;
    /**
     * 采购平台订单号
     * @type {string}
     * @memberof NormalOrderCheckInfoOrderCheckGoodsVo
     */
    purchasePlatformOrderNo?: string;
    /**
     * 商品状态
     * @type {number}
     * @memberof NormalOrderCheckInfoOrderCheckGoodsVo
     */
    goodsStatus?: number;
    /**
     * 商品状态名称
     * @type {string}
     * @memberof NormalOrderCheckInfoOrderCheckGoodsVo
     */
    goodsStatusName?: string;
    /**
     * 处理方式 1 废弃, 2 退货, 3 无视错误, 4 仅退款, 5 重新检查， 6 补发
     * @type {number}
     * @memberof NormalOrderCheckInfoOrderCheckGoodsVo
     */
    processMethod?: number;
}

/**
 * Check if a given object implements the NormalOrderCheckInfoOrderCheckGoodsVo interface.
 */
export function instanceOfNormalOrderCheckInfoOrderCheckGoodsVo(value: object): value is NormalOrderCheckInfoOrderCheckGoodsVo {
    return true;
}

export function NormalOrderCheckInfoOrderCheckGoodsVoFromJSON(json: any): NormalOrderCheckInfoOrderCheckGoodsVo {
    return NormalOrderCheckInfoOrderCheckGoodsVoFromJSONTyped(json, false);
}

export function NormalOrderCheckInfoOrderCheckGoodsVoFromJSONTyped(json: any, ignoreDiscriminator: boolean): NormalOrderCheckInfoOrderCheckGoodsVo {
    if (json == null) {
        return json;
    }
    return {
        
        'goodsId': json['goodsId'] == null ? undefined : json['goodsId'],
        'checkOrderId': json['checkOrderId'] == null ? undefined : json['checkOrderId'],
        'goodsCode': json['goodsCode'] == null ? undefined : json['goodsCode'],
        'skuId': json['skuId'] == null ? undefined : json['skuId'],
        'skuCode': json['skuCode'] == null ? undefined : json['skuCode'],
        'goodsImgUrl': json['goodsImgUrl'] == null ? undefined : json['goodsImgUrl'],
        'goodsName': json['goodsName'] == null ? undefined : json['goodsName'],
        'goodsColor': json['goodsColor'] == null ? undefined : json['goodsColor'],
        'goodsSize': json['goodsSize'] == null ? undefined : json['goodsSize'],
        'goodsQuantity': json['goodsQuantity'] == null ? undefined : json['goodsQuantity'],
        'trackingNumber': json['trackingNumber'] == null ? undefined : json['trackingNumber'],
        'purchasePlatformOrderNo': json['purchasePlatformOrderNo'] == null ? undefined : json['purchasePlatformOrderNo'],
        'goodsStatus': json['goodsStatus'] == null ? undefined : json['goodsStatus'],
        'goodsStatusName': json['goodsStatusName'] == null ? undefined : json['goodsStatusName'],
        'processMethod': json['processMethod'] == null ? undefined : json['processMethod'],
    };
}

export function NormalOrderCheckInfoOrderCheckGoodsVoToJSON(json: any): NormalOrderCheckInfoOrderCheckGoodsVo {
    return NormalOrderCheckInfoOrderCheckGoodsVoToJSONTyped(json, false);
}

export function NormalOrderCheckInfoOrderCheckGoodsVoToJSONTyped(value?: NormalOrderCheckInfoOrderCheckGoodsVo | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'goodsId': value['goodsId'],
        'checkOrderId': value['checkOrderId'],
        'goodsCode': value['goodsCode'],
        'skuId': value['skuId'],
        'skuCode': value['skuCode'],
        'goodsImgUrl': value['goodsImgUrl'],
        'goodsName': value['goodsName'],
        'goodsColor': value['goodsColor'],
        'goodsSize': value['goodsSize'],
        'goodsQuantity': value['goodsQuantity'],
        'trackingNumber': value['trackingNumber'],
        'purchasePlatformOrderNo': value['purchasePlatformOrderNo'],
        'goodsStatus': value['goodsStatus'],
        'goodsStatusName': value['goodsStatusName'],
        'processMethod': value['processMethod'],
    };
}

